import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environment/environment';
import { Observable, catchError, map, throwError } from 'rxjs';
import { RoleList, UserAddDto, UserList, UserMenuRightClass, UserMenuRights, UserParams } from './user.model';
import { DatePipe } from '@angular/common';
import { AuthService } from 'app/core/auth/auth.service';
import { User } from 'app/core/user/user.types';
import { deleteclass } from 'app/modules/quotation/quotation.model';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  user: User;
  private apiUrl: string;
  private createdby: number;
  private partner_id: number;
  private company_id: number;
  datePipe: DatePipe = new DatePipe('en-US');

  constructor(private _httpClient: HttpClient, private _authService: AuthService) {
    this.apiUrl = environment.baseUrl;
    this.user = JSON.parse(_authService.accessUser);
  }



  getAll_1(userParams: UserParams): Observable<any> {

    let params = new HttpParams();
    if (userParams.Search && userParams.Search !== undefined)
      params = params.append('Search', userParams.Search);

    params = params.append('PageNo', userParams.pageNo);
    params = params.append('PageSize', userParams.pageSize);
    return this._httpClient.get<UserList[]>(this.apiUrl + 'User/GetAllUser', {
      observe: 'body',
      params,
    });
  }

  getAll(search: string, rowsPerPage: number, page: number , UserID:number): Observable<UserList[]> {
    let params = new HttpParams();
    if (search && search !== undefined)
      params = params.append('Search', search);
    params = params.append('PageNo', page);
    params = params.append('PageSize', rowsPerPage);
    params = params.append('UserID', UserID);

    return this._httpClient.get<UserList[]>(this.apiUrl + 'User/GetAllUser', {
      observe: 'body',
      params,
    });
  }




  getRoleDropDownList(mode:string): Observable<any> {

    return this._httpClient.get<any>(this.apiUrl + 'User/GetRoleNameList/' + mode);
  }


  getimagepath(image: string): Observable<any> {

    return this._httpClient.get<any>(this.apiUrl + 'User/GetConfigValueone/' + image);
  }



  SaveUser(user: UserAddDto, imagefile: File): Observable<any> {

    var date = new Date();
    var transformDate = this.datePipe.transform(date, 'yyyy-MM-dd');



    user.action = "Insert";
    user.allowAllIps = false;

    user.allowIps = "1";
    user.passwordHash = "0f1V8fEP7CezBTm2ugSoYKJzTquA2KOl0DfUssh/yd81e2/CuY5JEfsWA4wR4PeTIy6X8l/ANgQeIy1WLIefiw==";
    user.passwordSalt = "lOQXidJyEwx6EdLQa8yF83lzwbyUUCUdAZA+ygLqaAUrLTA/fbKphI3D123jlksQ3pyaXuAgrbIjtY0zyld4tiT9fJ48dxZ8DgPVM35f8/YQElrxGWfQTXuvKG+8xA/RosVFZIHKla6Ak8HEWKQSbv52A5tfv87hXuvTA2FeI90=";
    user.randomCode = "123";
    user.company_id = this.user.company_id;
    user.createdBy = this.user.id;
    user.lastLoginDate = transformDate.toString();
    user.active = true;
    user.lastPasswordChangeDate = transformDate.toString();
    user.randomCodedate = transformDate.toString();
    user.fileUpload = imagefile;


    const formData = new FormData();
    Object.keys(user).forEach((key) => {

      formData.append(key, user[key]);
    });


    return this._httpClient.post<UserAddDto>(this.apiUrl + 'User/SaveUsers', formData).pipe(catchError(this.handleError));

  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }


  getUserById(id: number): Observable<any> {


    return this._httpClient.get<UserList[]>(this.apiUrl + 'User/GetUserDetailbyID/' + id);
  }


  GetUserNamelist(): Observable<any> {

    return this._httpClient.get<any>(this.apiUrl + 'UserMenuRights/GetUserNameList');
  }


  GetRoleDataById(role: UserMenuRights): Observable<any> {
    return this._httpClient.post<UserMenuRights>(this.apiUrl + 'UserLogin/GetUserLoginMenu', role).pipe(catchError(this.handleError));;
  }

  GetUserMenuListBYId(userid: number, userm: UserMenuRights): Observable<any> {



    userm.userid = userid;


    return this._httpClient.post<UserMenuRights>(this.apiUrl + 'UserMenuRights/GetUserMenu', userm).pipe(catchError(this.handleError));;
  }

    GetUserMenuListBYIdReport(userid: number, userm: UserMenuRights): Observable<any> {



    userm.userid = userid;


    return this._httpClient.post<UserMenuRights>(this.apiUrl + 'UserMenuRights/GetUserMenuReport', userm).pipe(catchError(this.handleError));;
  }

  SaveUserMenuRight(userid: number, umra: UserMenuRightClass): Observable<any> {

    var date = new Date();
    var transformDate = this.datePipe.transform(date, 'yyyy-MM-dd');
    umra.User_Id = userid;

    umra.company_id = 1;
    umra.active_indicator = 1;



    return this._httpClient.post<UserMenuRightClass>(this.apiUrl + 'UserMenuRights/SaveUserRightsMenu', umra).pipe(catchError(this.handleError));;
  }
  SaveUserMenuRightReport(userid: number, umra: UserMenuRightClass): Observable<any> {

    var date = new Date();
    var transformDate = this.datePipe.transform(date, 'yyyy-MM-dd');
    umra.User_Id = userid;

    umra.company_id = 1;
    umra.active_indicator = 1;



    return this._httpClient.post<UserMenuRightClass>(this.apiUrl + 'UserMenuRights/SaveUserRightsMenuReport', umra).pipe(catchError(this.handleError));;
  }
  getPartnerDropDownList(): Observable<any> {
    let mode = "user";
    return this._httpClient.get<any[]>(this.apiUrl + 'Quotation/GetBrokerNamelist/' + mode);

  }


  Deleteuser(clsdelete: deleteclass, id: number): Observable<any> {

    clsdelete.Id = id;

    return this._httpClient.post<any>(this.apiUrl + 'User/DeleteUser', clsdelete).pipe(catchError(this.handleError));


  }

}
